import React, { Component } from "react";

import Script from "react-load-script";

import { Icon, Button } from "semantic-ui-react";

class PlaidLinkButton extends Component {
  constructor(props) {
    super(props);

    this.state = {
      missingPlaid: !window.Plaid,
      error: false
    };
  }

  handleClick = e => {
    e.stopPropagation();
    if (this.props.handleOpen) {
      this.props.handleOpen(window.Plaid);
    }
  };

  handleError = () => {
    this.setState({
      error: true
    });
  };

  handleLoad = () => {
    if (window.Plaid) {
      this.setState({
        missingPlaid: false,
        error: false
      });
    } else {
      this.setState({
        error: true
      });
    }
  };

  render() {
    return (
      <div>
        <Button
          icon
          labelPosition="left"
          primary
          loading={this.props.loading || this.state.missingPlaid}
          onClick={this.handleClick}
          disabled={
            this.props.disabled ||
            this.props.loading ||
            this.state.missingPlaid ||
            this.state.error
          }
        >
          <Icon name="lock" />
          {this.props.message || "Securely connect another bank"}
        </Button>
        {this.state.missingPlaid && (
          <Script
            url="https://cdn.plaid.com/link/v2/stable/link-initialize.js"
            onError={this.handleError}
            onLoad={this.handleLoad}
          />
        )}
      </div>
    );
  }
}

export default PlaidLinkButton;



// WEBPACK FOOTER //
// ./frontend/src/components/PlaidLinkButton.js